/* Nativer MwSt-Umschalter (ersetzt t-selector-App).
   - Toggle-Sync (Header + Drawer), Persistenz per Cookie flexVat
   - Preis-Enhancer: App-gerenderte Preise (Boost-Filter, PageFly …) tragen kein
     dualPrice-Markup aus price.liquid — hier werden Preis-Texte clientseitig in
     .dp-gross/.dp-net gewrappt (19%). MutationObserver deckt Filter-/Lazy-
     Nachladen ab. price.liquid-Preise (schon .dualPrice) werden übersprungen. */
(function () {
  'use strict';
  if (window.__flexVat) return;
  window.__flexVat = true;

  var VAT = 1.19;
  var PRICE_RE = /(\d{1,3}(?:\.\d{3})*,\d{2})(\s*€)/g;

  function current() { return /(?:^|;\s*)flexVat=net/.test(document.cookie) ? 'net' : 'gross'; }
  function store(v) { document.cookie = 'flexVat=' + v + ';path=/;max-age=31536000;samesite=lax'; }

  function netOf(grossStr) {
    var cents = Math.round(parseFloat(grossStr.replace(/\./g, '').replace(',', '.')) * 100);
    var net = Math.round(cents / VAT) / 100;
    return net.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function apply(v) {
    document.documentElement.classList.toggle('vat-net', v === 'net');
    document.querySelectorAll('.vat-switcher-inline .t-selector-option').forEach(function (opt) {
      var b2b = opt.querySelector('[data-vat-type="b2b"]');
      var b2c = opt.querySelector('[data-vat-type="b2c"]');
      var cb = opt.querySelector('.t-selector-option-switch');
      if (b2b) b2b.classList.toggle('active', v === 'net');
      if (b2c) b2c.classList.toggle('active', v !== 'net');
      if (cb) cb.checked = v === 'net';
    });
  }

  function bindSwitchers() {
    document.querySelectorAll('.vat-switcher-inline .t-selector-option-switch').forEach(function (cb) {
      if (cb.__flexBound) return;
      cb.__flexBound = true;
      cb.addEventListener('change', function () {
        var v = cb.checked ? 'net' : 'gross';
        store(v);
        apply(v);
      });
    });
  }

  /* Preis-Elemente ohne dualPrice-Markup dual machen (nur Textknoten anfassen,
     Prefixe wie "Von " bleiben erhalten). */
  function enhance(root) {
    var els = (root || document).querySelectorAll(
      '.price-item, .boost-sd__format-currency, ' +
      '[data-pf-type="ProductPrice"], [data-pf-type="ProductPrice2"], [data-pf-type="ProductPrice2Item"], ' +
      // Nativer Cart-Drawer: Zeilenpreise, Gespart-Zeilen, Ersparnis, Zwischensumme.
      // Der Versandbalken bleibt bewusst brutto (999-€-Schwelle ist eine Brutto-Schwelle).
      '.cart-drawer .cart-item__details .product-option, .flex-cart-item-saving, ' +
      '.flex-cart-savings__amount, .cart-drawer .totals__subtotal-value, ' +
      '#main-cart-items .cart-item__details .product-option, ' +
      '#main-cart-items .cart-item__price-wrapper, #main-cart-footer .totals__subtotal-value'
    );
    els.forEach(function (el) {
      // Skip NUR auf eigenem Markup (.dp-net / flex-dual). ACHTUNG: das
      // shopweite money_format rendert selbst <span class=dualPrice> um jede
      // Zahl (t-selector-Altlast) — solche nackten Spans MÜSSEN enhanced werden.
      if (el.dataset.vatDual || el.querySelector('.dp-net') || el.closest('.flex-dual')) return;
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      var nodes = [];
      while (walker.nextNode()) {
        if (PRICE_RE.test(walker.currentNode.nodeValue)) nodes.push(walker.currentNode);
        PRICE_RE.lastIndex = 0;
      }
      if (!nodes.length) return;
      nodes.forEach(function (node) {
        // Nicht in bereits (von uns) gewrappten Spans arbeiten
        if (node.parentElement && node.parentElement.closest('.flex-dual')) return;
        var frag = document.createDocumentFragment();
        var text = node.nodeValue;
        var last = 0, m;
        PRICE_RE.lastIndex = 0;
        while ((m = PRICE_RE.exec(text)) !== null) {
          if (m.index > last) frag.appendChild(document.createTextNode(text.slice(last, m.index)));
          var span = document.createElement('span');
          span.className = 'flex-dual';
          span.innerHTML =
            '<span class="dp-gross">' + m[1] + m[2] + '</span>' +
            '<span class="dp-net">' + netOf(m[1]) + m[2] + '</span>';
          frag.appendChild(span);
          last = m.index + m[0].length;
        }
        if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
        node.parentNode.replaceChild(frag, node);
      });
      el.dataset.vatDual = '1';
    });
  }

  var pending = null;
  function scheduleEnhance() {
    if (pending) return;
    pending = setTimeout(function () {
      pending = null;
      enhance(document);
      bindSwitchers();
      apply(current());
    }, 120);
  }

  function init() {
    bindSwitchers();
    apply(current());
    enhance(document);
    // Boost/App-Inhalte laden nach — nachziehen.
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { scheduleEnhance(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Desktop-Kaufzeile: Mengenfeld exakt auf die gerenderte Hoehe des
   Warenkorb-Buttons bringen (Subpixel-genau, ResizeObserver-nachgefuehrt).
   Mobil (gestapelt) bleibt die natuerliche Feldhoehe. */
(function () {
  function findBtn() {
    return document.querySelector('.product__info-container button[name="add"]');
  }
  function findQty() {
    return document.querySelector('.product__info-container .product-form__quantity .quantity');
  }
  function sync() {
    var q = findQty();
    if (!q) return;
    if (!window.matchMedia('(min-width: 990px)').matches) {
      q.style.height = '';
      return;
    }
    var btn = findBtn();
    if (!btn) return;
    var h = btn.getBoundingClientRect().height;
    if (h > 0) q.style.height = h + 'px';
  }
  function init() {
    var btn = findBtn();
    if (!btn) return;
    sync();
    if (window.ResizeObserver) new ResizeObserver(sync).observe(btn);
    window.addEventListener('resize', sync);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
